export default "__VITE_ASSET__Ez7SJJbX__"